import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtOI(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  return a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
}
function num(v) { return v == null ? '--' : Number(v).toLocaleString('en-IN'); }
function fmtCr(v) {
  if (v == null || isNaN(v)) return '--';
  return (v > 0 ? '+' : v < 0 ? '−' : '') + Math.abs(v).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' Cr';
}

var C = { mut: '#556677', sub: '#8b98a9', red: '#ef4444', grn: '#22c55e', blu: '#38bdf8', amb: '#fbbf24', vio: '#a78bfa' };

function MiniChart(props) {
  var rows = props.rows || [], tab = props.tab, v = props.view || {}, s = v.suggestion || {};
  if (!rows.length) return <div style={{ fontSize: 10, color: C.mut, padding: '30px 0', textAlign: 'center' }}>Waiting for chain…</div>;
  var W = 360, H = 170, L = 6, R = 6, T = 14, B = 18, n = rows.length, cw = (W - L - R) / n;
  var mid = T + (H - T - B) / 2, base = H - B, ph = H - T - B, els = [];
  var picks = [s.ce_strike, s.pe_strike];
  if (tab === 'oi') {
    var mx = Math.max.apply(null, rows.map(function (r) { return Math.max(r.ce_oi || 0, r.pe_oi || 0); })) || 1;
    rows.forEach(function (r, i) {
      var x = L + i * cw, hi = picks.indexOf(r.strike) > -1;
      var hc = (r.ce_oi || 0) / mx * ph, hp = (r.pe_oi || 0) / mx * ph;
      els.push(<rect key={'c' + i} x={x + cw * 0.1} y={base - hc} width={cw * 0.4} height={hc} fill={C.red} opacity={hi ? 1 : 0.5} />);
      els.push(<rect key={'p' + i} x={x + cw * 0.5} y={base - hp} width={cw * 0.4} height={hp} fill={C.grn} opacity={hi ? 1 : 0.5} />);
    });
  } else {
    var key = tab === 'gex' ? 'net_gex' : 'fresh_dex';
    var vals = rows.map(function (r) { return r[key] || 0; });
    var m2 = Math.max.apply(null, vals.map(Math.abs)) || 1;
    rows.forEach(function (r, i) {
      var val = vals[i], h = Math.abs(val) / m2 * ph / 2, y = val >= 0 ? mid - h : mid;
      els.push(<rect key={i} x={L + i * cw + cw * 0.15} y={y} width={cw * 0.7} height={h} fill={val >= 0 ? C.grn : C.red} opacity={0.75} />);
    });
    els.push(<line key="m" x1={L} x2={W - R} y1={mid} y2={mid} stroke="#26334a" />);
  }
  var k0 = rows[0].strike, step = n > 1 ? rows[1].strike - k0 : 50;
  if (v.spot) {
    var sx = L + (v.spot - k0) / step * cw + cw / 2;
    els.push(<line key="s" x1={sx} x2={sx} y1={T} y2={H - B} stroke={C.blu} strokeDasharray="3 3" />);
  }
  rows.forEach(function (r, i) {
    if (r.strike % 200 === 0) els.push(<text key={'t' + i} x={L + i * cw + cw / 2} y={H - 4} fill={C.mut} fontSize="8" textAnchor="middle">{r.strike}</text>);
  });
  return <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', height: 'auto', display: 'block' }}>{els}</svg>;
}


function hmsToSec(t) { var p = String(t || '').split(':'); return (+p[0] || 0) * 3600 + (+p[1] || 0) * 60 + (+p[2] || 0); }
var BT_START = hmsToSec('09:17:00'), BT_END = hmsToSec('15:30:00');
// Mobile flow-bias timeline — Hybrid Conviction mobile style (sign-coloured segments)
function BiasTimelineM(props) {
  var h = props.history || [];
  var has = h.length >= 2;
  var W = 350, H = 100, PL = 25;
  function toX(t) { return PL + Math.max(0, Math.min(1, (hmsToSec(t) - BT_START) / (BT_END - BT_START))) * (W - PL - 10); }
  function toY(v) { return 50 - (Math.max(-100, Math.min(100, v)) / 100) * 40; }
  var G = '#00d4aa', R = '#ff4466', M = '#4a5c72', thr = (props.threshold || 0.25) * 100;
  var segs = [];
  for (var i = 0; i < h.length - 1; i++) {
    var a = (h[i].bias || 0) * 100, b = (h[i + 1].bias || 0) * 100;
    var c = (a >= 0 && b >= 0) ? G : (a <= 0 && b <= 0) ? R : '#8899aa';
    segs.push(<line key={i} x1={toX(h[i].time)} y1={toY(a)} x2={toX(h[i + 1].time)} y2={toY(b)} stroke={c} strokeWidth="1.5" />);
  }
  var last = h[h.length - 1] || { time: '09:17:00', bias: 0 }, lv = (last.bias || 0) * 100;
  return (
    <div style={{ background: 'rgba(12,18,32,0.95)', borderRadius: 14, border: '1px solid rgba(26,45,74,0.35)', padding: '10px 8px', marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 8, color: M, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4, padding: '0 6px' }}>
        <span>Flow bias timeline</span>{has ? <span style={{ color: lv > 8 ? G : lv < -8 ? R : '#8899aa' }}>{lv >= 0 ? '+' : ''}{Math.round(lv)}</span> : null}
      </div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', height: H }}>
        <line x1={PL} y1="50" x2={W - 10} y2="50" stroke="rgba(100,120,140,0.2)" strokeWidth="0.5" />
        <line x1={PL} y1={toY(thr)} x2={W - 10} y2={toY(thr)} stroke={G + '30'} strokeDasharray="2" />
        <line x1={PL} y1={toY(-thr)} x2={W - 10} y2={toY(-thr)} stroke={R + '30'} strokeDasharray="2" />
        {segs}
        {has ? <circle cx={toX(last.time)} cy={toY(lv)} r="3" fill={lv >= 0 ? G : R} stroke="#05080f" strokeWidth="1.5" /> : null}
        {!has ? <text x="187" y="44" textAnchor="middle" fill={M} fontSize="8">No data yet — fills from 09:17</text> : null}
        <text x={PL - 3} y="12" textAnchor="end" fill={M} fontSize="7">+100</text>
        <text x={PL - 3} y="53" textAnchor="end" fill={M} fontSize="7">0</text>
        <text x={PL - 3} y="96" textAnchor="end" fill={M} fontSize="7">-100</text>
        {['09:17:00', '11:00:00', '13:00:00', '15:30:00'].map(function (t) { return <text key={t} x={toX(t)} y="98" textAnchor="middle" fill={M} fontSize="6">{t.slice(0, 5)}</text>; })}
      </svg>
    </div>
  );
}

var PositioningM = function () {
  var [state, setState] = useState(null);
  var [tab, setTab] = useState('gex');

  var fetchState = useCallback(function () {
    fetch(API + '/positioning/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) setState(d);
    }).catch(function () {});
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 2000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var v = (state && state.view) || {};
  var s = v.suggestion || {};
  var cfg = (state && state.config) || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px', marginBottom: 10 };
  var conf = s.confidence || 0;
  var confCol = conf >= 65 ? C.grn : conf >= 40 ? C.amb : C.red;
  var stCol = { ok: C.grn, warn: C.amb, bad: C.red }, stSym = { ok: '✓', warn: '~', bad: '✗' };
  var pos_ = v.regime === 'positive';
  var bias = v.bias || 0;
  var biasLbl = bias > 0.25 ? 'Bullish' : bias > 0.08 ? 'Slightly bullish' : bias < -0.25 ? 'Bearish' : bias < -0.08 ? 'Slightly bearish' : 'Neutral';
  var biasCol = bias > 0.08 ? C.grn : bias < -0.08 ? C.red : C.sub;

  return (
    <div style={{ padding: '14px 14px 80px', color: '#e5e7eb', fontFamily: 'inherit', height: '100%', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 18, fontWeight: 800 }}>🧭 Positioning</span>
        {v.regime ? <span style={{ fontSize: 8, fontWeight: 800, color: pos_ ? C.grn : C.red, border: '1px solid ' + (pos_ ? C.grn : C.red) + '80', borderRadius: 6, padding: '2px 6px' }}>{pos_ ? '+GAMMA · RANGE' : '−GAMMA · TREND'}</span> : null}
      </div>
      <div style={{ fontSize: 9, color: C.mut, marginBottom: 10 }}>exp {v.expiry_iso || '--'} · {(state && state.view_time) || '--'} · settings on desktop</div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {[['SPOT', v.spot ? Math.round(v.spot) : null], ['FLIP', v.gamma_flip], ['GEX', v.net_gex != null ? Math.round(v.net_gex) : null], ['EM ±', v.expected_move ? Math.round(v.expected_move) : null]].map(function (x) {
          return <div key={x[0]} style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 4px', textAlign: 'center' }}>
            <div style={{ fontSize: 8, fontWeight: 800, color: C.mut }}>{x[0]}</div>
            <div style={{ fontSize: 13, fontWeight: 800 }}>{num(x[1])}</div>
          </div>;
        })}
      </div>

      <div style={{ ...card, borderColor: 'rgba(167,139,250,0.45)' }}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: C.vio }}>SUGGESTED STRANGLE</div>
        {s.action === 'AVOID' ? <div style={{ color: C.red, fontWeight: 800, fontSize: 12, padding: '10px 0' }}>NO TRADE — negative gamma</div>
          : s.ce_strike ? (
            <div style={{ display: 'flex', gap: 8, margin: '8px 0' }}>
              {[['SELL CE', s.ce_strike, s.ce_ltp, C.red], ['SELL PE', s.pe_strike, s.pe_ltp, C.grn]].map(function (x) {
                return <div key={x[0]} style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: 8, textAlign: 'center' }}>
                  <div style={{ fontSize: 8, fontWeight: 800, color: x[3] }}>{x[0]}</div>
                  <div style={{ fontSize: 20, fontWeight: 800 }}>{num(x[1])}</div>
                  <div style={{ fontSize: 10, color: C.sub }}>₹{x[2]}</div>
                </div>;
              })}
            </div>
          ) : <div style={{ fontSize: 10, color: C.mut, padding: '10px 0' }}>No qualifying strikes yet.</div>}
        {s.credit ? <div style={{ fontSize: 10, color: C.sub }}>Credit ₹{s.credit} · BE {num(s.be_low)}–{num(s.be_high)}</div> : null}
        <div style={{ height: 6, background: '#0d1524', borderRadius: 6, overflow: 'hidden', marginTop: 8 }}><div style={{ width: conf + '%', height: '100%', background: confCol }} /></div>
        <div style={{ fontSize: 10, fontWeight: 800, color: confCol, marginTop: 3 }}>{conf}/100</div>
        <div style={{ marginTop: 6, fontSize: 10, lineHeight: 1.7 }}>
          {(s.reasons || []).map(function (r, i) { return <div key={i}><span style={{ color: stCol[r.st], fontWeight: 800 }}>{stSym[r.st]}</span> <b>{r.sig}</b> — {r.text}</div>; })}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: C.mut, marginBottom: 6 }}>DEALER / FLOW BIAS</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ fontWeight: 800, fontSize: 14, color: biasCol }}>{biasLbl}</span>
          <span style={{ fontSize: 11, fontWeight: 800, color: biasCol }}>{bias >= 0 ? '+' : ''}{Math.round(bias * 100)}</span>
        </div>
        <div style={{ height: 8, background: '#0d1524', borderRadius: 6, margin: '8px 0', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', left: bias >= 0 ? '50%' : (50 + bias * 50) + '%', width: Math.abs(bias) * 50 + '%', height: '100%', background: biasCol }} />
          <div style={{ position: 'absolute', left: '50%', top: 0, width: 2, height: '100%', background: C.mut }} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 10px', fontSize: 10, color: C.sub }}>
          <span>Call GEX <b style={{ color: '#e5e7eb' }}>{fmtCr(v.call_gex)}</b></span>
          <span>Put GEX <b style={{ color: '#e5e7eb' }}>{fmtCr(v.put_gex)}</b></span>
          <span>Total DEX <b style={{ color: '#e5e7eb' }}>{fmtCr(v.net_dex)}</b></span>
          <span>Fresh DEX <b style={{ color: biasCol }}>{fmtCr(v.fresh_dex)}</b></span>
        </div>
      </div>

      <BiasTimelineM history={state && state.bias_history} threshold={cfg.dex_tilt_threshold} />

      <div style={card}>
        <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
          {[['gex', 'GEX'], ['dex', 'DEX'], ['oi', 'OI']].map(function (t) {
            var on = tab === t[0];
            return <button key={t[0]} onClick={function () { setTab(t[0]); }} style={{ flex: 1, fontSize: 10, fontWeight: 800, borderRadius: 6, padding: '5px 0', fontFamily: 'inherit', cursor: 'pointer', background: on ? 'rgba(56,189,248,0.15)' : '#0d1524', color: on ? C.blu : C.sub, border: '1px solid ' + (on ? 'rgba(56,189,248,0.5)' : '#26334a') }}>{t[1]}</button>;
          })}
        </div>
        <MiniChart rows={v.chart} tab={tab} view={v} />
      </div>

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: C.mut }}>PAPER{state && state.day_stopped ? ' · ' + state.day_stopped : ''}</span>
          <span style={{ fontSize: 12, fontWeight: 800, color: (st.day_pnl || 0) >= 0 ? C.grn : C.red }}>{fmtINR(st.day_pnl)}</span>
        </div>
        {pos ? pos.legs.map(function (l, i) {
          return <div key={i} style={{ fontSize: 10, color: C.sub, padding: '3px 0' }}>
            SELL {l.strike} {l.side} @ {l.entry} → {l.ltp}
            <span style={{ fontSize: 8, color: C.mut, marginLeft: 4 }}>{l.rank ? '#' + l.rank : '-'} · Δ{l.delta != null ? l.delta : '--'}</span>
            {state.pending_roll && state.pending_roll[l.side] ? <span style={{ fontSize: 8, color: C.amb, marginLeft: 4 }}>{state.pending_roll[l.side].why} → {state.pending_roll[l.side].strike}</span> : null}
            <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? C.grn : C.red }}>{fmtINR(l.pnl)}</span>
          </div>;
        }) : <div style={{ fontSize: 10, color: C.mut, textAlign: 'center', padding: '6px 0' }}>{state && state.entered_today ? 'Done for the day.' : 'Flat — enters at ' + (cfg.entry_time || '09:17') + '.'}</div>}
        <div style={{ fontSize: 9, color: C.mut, marginTop: 4 }}>rolls CE {st.rolls_ce || 0} · PE {st.rolls_pe || 0} · trades {st.trades || 0}</div>
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: C.mut, marginBottom: 6 }}>WALLS</div>
        <div style={{ display: 'flex', gap: 10, fontSize: 10 }}>
          {[['CALL', v.call_table, C.red, s.ce_strike], ['PUT', v.put_table, C.grn, s.pe_strike]].map(function (g) {
            return <div key={g[0]} style={{ flex: 1 }}>
              <div style={{ fontSize: 8, fontWeight: 800, color: g[2], marginBottom: 3 }}>{g[0]}</div>
              {(g[1] || []).map(function (r) {
                return <div key={r.strike} style={{ display: 'flex', justifyContent: 'space-between', fontWeight: r.strike === g[3] ? 800 : 400, color: r.strike === g[3] ? '#e5e7eb' : C.sub }}>
                  <span>{r.strike}</span><span>{fmtOI(r.oi)}</span><span>{(r.score || 0).toFixed(2)}</span>
                </div>;
              })}
            </div>;
          })}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: C.amb, marginBottom: 6 }}>KEY TAKEAWAYS</div>
        <ol style={{ margin: 0, paddingLeft: 14, fontSize: 10, lineHeight: 1.7, color: C.sub }}>
          {(v.takeaways || []).map(function (t, i) { return <li key={i}>{t}</li>; })}
        </ol>
      </div>
    </div>
  );
};

export default PositioningM;
